var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          [_c("Breadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c("table", { staticClass: "table table-hover table-sm mt-1" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.getSortedStores(), function (div) {
                return _c("tr", [
                  _c("td", [_vm._v(_vm._s(div.id))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(div.title))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    _vm._l(div.cities, function (city) {
                      return _c("p", { staticClass: "mb-1" }, [
                        _vm._v(_vm._s(city.city.name)),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-info",
                        on: {
                          click: function ($event) {
                            return _vm.mixinGoToRouter("BranchStoreStatus", {
                              id: div.stores[0].object_id,
                            })
                          },
                        },
                      },
                      [_vm._v("Наличие\n              ")]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Название")]),
        _vm._v(" "),
        _c("th", [_vm._v("Города")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }